import Link from 'next-translate-routes/link';
import { useRouter } from 'next-translate-routes/router';
import type { FC } from 'react';
import { useMemo } from 'react';

import { cn } from '@/utils';
import { getFreedom24DirectUrl } from '@/utils/advertisements/getFreedom24DirectUrl';

interface AdvertisementBannerProps {
  className?: string;
}
export const AdvertisementBanner: FC<AdvertisementBannerProps> = ({
  className,
}) => {
  const router = useRouter();

  const localePath = useMemo(() => {
    if (['de', 'en', 'es', 'it', 'nl'].includes(router.locale || 'en')) {
      return router.locale;
    }
    return 'en';
  }, [router?.locale]);

  return (
    <Link
      href={getFreedom24DirectUrl(router.locale || 'en')}
      className={cn('', className)}
    >
      <img
        className="sm:hidden"
        src={`/assets/banners/freedom/${localePath}/335x458.jpg`}
        alt="promo banner"
      />
      <img
        className="hidden sm:block md:hidden"
        src={`/assets/banners/freedom/${localePath}/460x398.jpg`}
        alt="promo banner"
      />
      <img
        className="hidden md:block lg:hidden"
        src={`/assets/banners/freedom/${localePath}/660x304.jpg`}
        alt="promo banner"
      />
      <img
        className="hidden lg:block xl:hidden"
        src={`/assets/banners/freedom/${localePath}/888x264.jpg`}
        alt="promo banner"
      />
      <img
        className="hidden xl:block"
        src={`/assets/banners/freedom/${localePath}/888x264.jpg`}
        alt="promo banner"
      />
    </Link>
  );
};
